import { action, flow, makeObservable, observable } from "mobx";
import { API } from "aws-amplify";
import {
  // [DEPRECATED_GRAPHQL] - Para eliminación: fetchAlerts usa GraphQL query getAlert
  // TODO: Eliminar después de verificar que nuevas APIs funcionan correctamente
  
  // getAlert,
  // [DEPRECATED_GRAPHQL] - Para eliminación: getUCP, fetchUCPData y fetchVehicleVinPictures usan GraphQL queries
  // TODO: Eliminar después de verificar que nuevas APIs funcionan correctamente
  
  // getContacts,
  // getData,
  // getVehicleVinPictures,
  // getAnnUserContact,
} from "../../graphql/queries";



class UnifiedCustomerProfileStore {
  ucp = {};
  typeUrl = "";
  notifications = [];
  garage = [];
  selectedCar = null;
  scheduledAppointments = [];
  orders = [];
  parts = [];
  contactInfo = [];
  garageInfo = [];
  repairOrdersInfo = [];
  appointmentsInfo = [];
  opportunitiesInfo = [];
  initialLoad = false;
  isLoading = false;
  isError = false;
  notAuthorized = false;
  scrollPosition = 0;
  alerts = [];
  imageGallery = [];
  vehicleVinPictures = [];
  isLoadingVehicleImages = false;
  dealershipTeamData = [];
  vinChangedLoading = false;

  constructor() {
    makeObservable(this, {
      ucp: observable,
      initialLoad: observable,
      notifications: observable,
      garage: observable,
      selectedCar: observable,
      scheduledAppointments: observable,
      orders: observable,
      parts: observable,
      isLoading: observable,
      isError: observable,
      notAuthorized: observable,
      contactInfo: observable,
      garageInfo: observable,
      repairOrdersInfo: observable,
      appointmentsInfo: observable,
      opportunitiesInfo: observable,
      typeUrl: observable,
      scrollPosition: observable,
      alerts: observable,
      imageGallery: observable,
      vehicleVinPictures: observable,
      isLoadingVehicleImages: observable,
      vinChangedLoading: observable,
      dealershipTeamData: observable,
      // [DEPRECATED_GRAPHQL] - Para eliminación: getUCP, fetchUCPData y fetchVehicleVinPictures usan GraphQL queries
      // TODO: Eliminar después de verificar que nuevas APIs funcionan correctamente
      
      // getUCP: flow,
      // fetchUCPData: flow,
      // [DEPRECATED_GRAPHQL] - Método que usa GraphQL query getAlert
      // fetchAlerts: flow,
      // fetchVehicleVinPictures: flow,
      formatOppotunities: action,
      onClearUCP: action,
      getScheduledAppointments: action,
      getNotifications: action,
      getGarage: action,
      getOrders: action,
      getParts: action,
      setSelectedCar: action,
      setScrollPosition: action,
      changeUrl: action,
    });
  }

  onClearUCP() {
    this.ucp = {};
    this.notifications = [];
    this.garage = [];
    this.selectedCar = null;
    this.scheduledAppointments = [];
    this.orders = [];
    this.parts = [];
    this.contactInfo = [];
    this.garageInfo = [];
    this.repairOrdersInfo = [];
    this.appointmentsInfo = [];
    this.notAuthorized = false;
    this.initialLoad = false;
    this.isError = false;
    this.alerts = [];
    this.isLoadingVehicleImages = false;
    this.vehicleVinPictures = [];
    this.opportunitiesInfo = [];
    this.dealershipTeamData = [];
    this.vinChangedLoading = false;
  }

  // [DEPRECATED_GRAPHQL] - Para eliminación: Usa GraphQL query getContacts
  // TODO: Eliminar después de verificar que nuevas APIs funcionan correctamente
  
  // *getUCP(customer, segment_id) {
  //   try {
  //     this.isLoading = true;
  //     const response = yield API.graphql({
  //       query: getContacts,
  //       variables: {
  //         input: { customer: customer, segment_id },
  //       },
  //       authMode: "AMAZON_COGNITO_USER_POOLS",
  //     });

  //     const data = JSON.parse(response.data?.getContacts?.body);
  //     if (!data.hasOwnProperty(segment_id)) throw new Error();

  //     this.ucp = data[segment_id];
  //     this.initialLoad = true;
  //   } catch (error) {
  //     this.isError = true;
  //   } finally {
  //     this.isLoading = false;
  //   }
  // }

  // [DEPRECATED_GRAPHQL] - Para eliminación: Usa GraphQL queries getAnnUserContact y getData
  // TODO: Eliminar después de verificar que nuevas APIs funcionan correctamente
  
  // *fetchUCPData(customer_id, contact_id, card_name, user_id, isGroupSuperAdmin) {
  //   try {
  //     const getAnnUserContactResponse = yield API.graphql({
  //       query: getAnnUserContact,
  //       variables: {
  //         input: { customer: customer_id, contact_id, user_id },
  //       },
  //       authMode: "AMAZON_COGNITO_USER_POOLS",
  //     });

  //     if (
  //       /^[45]\d{2}$/.test(
  //         getAnnUserContactResponse.data?.getAnnUserContact?.statusCode
  //       ) && !isGroupSuperAdmin
  //     ) {
  //       this.notAuthorized = true;
  //       return;
  //     }

  //     const requestInput = {
  //       customer: customer_id,
  //       parameters: {
  //         contact_id,
  //         cards: [],
  //       },
  //       source: "CONTACT_UCP"
  //     }

  //     if(["card_opportunity", "card_orders"].includes(card_name)){
  //       requestInput.parameters.cards.push({
  //         card_name,
  //         filters: [{
  //           "id": "vin_no",
  //           "value": this.selectedCar
  //         }]
  //       })
  //       this.vinChangedLoading = true;
  //     } else {
  //       this.isLoading = true;
  //       requestInput.parameters.cards.push({
  //         card_name,
  //       })
  //     }

  //     requestInput.parameters = JSON.stringify(requestInput.parameters)

  //     const response = yield API.graphql({
  //       query: getData,
  //       variables: {
  //         input: requestInput,
  //       },
  //       authMode: "AMAZON_COGNITO_USER_POOLS",
  //     });

  //     const data = JSON.parse(response.data?.getData?.body);
  //     if (!data.hasOwnProperty(card_name)) throw new Error();
  //     if (card_name === "card_contact_info") {
  //       this.contactInfo = data[card_name];
  //     } else if (card_name === "card_garage") {
  //       this.garageInfo = data[card_name];
  //       this.selectedCar = this.garageInfo[0].vin_no;
  //     } else if (card_name === "card_orders") {
  //       this.repairOrdersInfo = data[card_name];
  //     } else if (card_name === "card_appointments") {
  //       this.appointmentsInfo = data[card_name];
  //     } else if(card_name === "card_team") {
  //       this.dealershipTeamData = data[card_name];
  //     } else if (card_name === "card_opportunity") {
  //       this.formatOppotunities(data[card_name][0])
  //     }
  //     this.initialLoad = true;
  //     this.notAuthorized = false;
  //   } catch (error) {
  //     this.isError = true;
  //   } finally {
  //     this.isLoading = false;
  //     this.vinChangedLoading = false;
  //   }
  // }

  getScheduledAppointments() {
    this.scheduledAppointments = this.selectedCar.appointments;
  }

  getNotifications() {
    this.notifications = this.ucp.notifications.map((notification, idx) => ({
      ...notification,
      id: idx + 1,
    }));
  }

  getGarage() {
    this.garage = this.ucp.cars.map((car) => ({
      ...car,
      complete_car_name: `${car.brand} ${car.model} ${car.year}`,
    }));
    this.selectedCar = this.garage[0];
  }

  getOrders() {
    this.orders = this.selectedCar.orders;
  }

  getParts() {
    if (this.selectedCar.parts) {
      this.parts = this.selectedCar.parts.map((part, idx) => ({
        ...part,
        id: idx + 1,
      }));
    }
  }

  setSelectedCar(vin) {
    this.selectedCar = vin;
  }

  setScrollPosition(position) {
    this.scrollPosition = position;
  }

  changeUrl(url) {
    this.typeUrl = url;
  }

  // [DEPRECATED_GRAPHQL] - Para eliminación: Usa GraphQL query getAlert
  // TODO: Eliminar después de verificar que nuevas APIs funcionan correctamente
  
  // *fetchAlerts(customer_id, assignee, status, last_evaluated_key) {
  //   try {
  //     this.isLoading = true;

  //     const response = yield API.graphql({
  //       query: getAlert,
  //       variables: {
  //         input: {
  //           customer_id: customer_id,
  //           assignee: "",
  //           status: status,
  //           last_evaluated_key: last_evaluated_key && null,
  //         },
  //       },
  //       authMode: "AMAZON_COGNITO_USER_POOLS",
  //     });

  //     this.alerts = JSON.parse(response.data?.getAlert?.body);
  //     this.initialLoad = true;
  //   } catch (error) {
  //     this.isError = true;
  //   } finally {
  //     this.isLoading = false;
  //   }
  // }

  // [DEPRECATED_GRAPHQL] - Para eliminación: Usa GraphQL query getVehicleVinPictures
  // TODO: Eliminar después de verificar que nuevas APIs funcionan correctamente
  
  // *fetchVehicleVinPictures() {
  //   try {
  //     this.isLoadingVehicleImages = true;
  //     const response = yield API.graphql({
  //       query: getVehicleVinPictures,
  //       variables: {
  //         input: {
  //           vin: this.selectedCar,
  //         },
  //       },
  //       authMode: "AMAZON_COGNITO_USER_POOLS",
  //     });

  //     const images = JSON.parse(response.data?.getVehicleVinPictures?.body);
  //     const imageUrls = images.map((image) => image.url);
  //     this.vehicleVinPictures = imageUrls;
  //   } catch (error) {
  //     this.isError = true;
  //   } finally {
  //     this.isLoadingVehicleImages = false;
  //   }
  // }

  formatOppotunities(opportunitiesResponse) {

    const replacementVehicle = `${opportunitiesResponse["replacement_model_year"]} ${opportunitiesResponse["replacement_make_name"]} ${opportunitiesResponse["replacement_model_name"]}`
    const additionalCosts = new Intl.NumberFormat().format(parseInt(opportunitiesResponse["replacement_payment"])-parseInt(opportunitiesResponse["current_payment"]))
    const savings = new Intl.NumberFormat().format(parseInt(opportunitiesResponse["replacement_payment"])-parseInt(opportunitiesResponse["current_payment"]))
    const extendedWarranty = opportunitiesResponse["warranty_months_remaining"] ? 'Yes' : 'No';

    this.opportunitiesInfo = [
      {
        title: "Contract Alert",
        content: `Payments made ${opportunitiesResponse["payments_made"]}, remaining ${opportunitiesResponse["payments_remaining"]}`,
        display: opportunitiesResponse["is_contract_alert"]
      },
      {
        title: "Flex Alert",
        content: `Vehicle: ${replacementVehicle}, Term: ${opportunitiesResponse["replacement_term"]} months, Payment: ${opportunitiesResponse["replacement_payment"]}, Additional Cost: ${additionalCosts}`,
        display: opportunitiesResponse["is_flex_alert"]
      },
      {
        title: "Warranty Alert",
        content: `Remaining Coverage: ${opportunitiesResponse["warranty_months_remaining"]} months, Extended Warranty: ${extendedWarranty}`,
        display: opportunitiesResponse["is_warranty_alert"]
      },
      {
        title: "Service Alert",
        content: `Recent RO: ${opportunitiesResponse["open_date"]}`,
        display: opportunitiesResponse["is_service_alert"]
      },
      {
        title: "In Market Alert",
        content: `Purchase Likelihood: Likely to purchase within the next 90 days`,
        display: opportunitiesResponse["is_in_market_alert"]
      },
      {
        title: "In Market Engage",
        content: `The customer is actively looking the online inventory on the Dealership webpage`,
        display: opportunitiesResponse["is_market_engaged_alert"]
      },
      {
        title: "Pending Service",
        content: `RO Scheduled: ${opportunitiesResponse["ro_appt_date"]}`,
        display: opportunitiesResponse["is_pending_service"]
      },
      {
        title: "Mileage Alert",
        content: `Projected Mileage: ${opportunitiesResponse["estimated_current_mileage"]} miles, Penalty: Current ${opportunitiesResponse["current_over_mileage_penalty"]}, Projected ${opportunitiesResponse["estimated_over_mileage_penalty"]}`,
        display: opportunitiesResponse["is_mileage_alert"]
      },
      {
        title: "Upgrade Alert",
        content: `Vehicle: ${replacementVehicle}, Term: ${opportunitiesResponse["replacement_term"]} months, Payment: ${new Intl.NumberFormat().format(opportunitiesResponse["replacement_payment"])}, Savings: ${savings} less`,
        display: opportunitiesResponse["is_upgrade_alert"]
      }
    ];

    this.opportunitiesInfo = this.opportunitiesInfo.every(info => !info.display) ? [] : this.opportunitiesInfo;
  }
}

export default UnifiedCustomerProfileStore;
